export default __webpack_public_path__ + "static/media/idcard_back.8bee2be3.jpg";